<template>
    <v-card flat elevation="0" class="d-flex flex-column bible-form" height="100%" max-height="515px" min-width="724px">
        <v-card-title style="height: 52px">
            <span class="header2">{{ $tc('data_records.columns_customization') }}</span>
        </v-card-title>
        <v-card-text style="padding-top: 0 !important;">
            <v-container class="custom-container">
                <div class="d-flex justify-space-between" style="gap: 8px">
                    <div class="d-flex flex-column draggable-columns--section">
                        <span>{{ $tc('data_records.visible_columns') }}</span>
                        <div class="overflow-y-auto background py-1">
                            <draggable :list="columns" group="headers" @change="changeOrder">
                                <v-list-item class="main-list" dense v-for="(data, key) in columns" :key="key"
                                             :value="data" v-if="data.show">
                                    <v-list-item-content class="main-list--content">
                                        <span>{{ data.title }}</span>
                                    </v-list-item-content>
                                </v-list-item>
                            </draggable>
                        </div>
                    </div>
                    <div class="d-flex align-center draggable-columns--icon">
                        <v-icon>
                            mdi mdi-swap-horizontal
                        </v-icon>
                    </div>
                    <div class="d-flex flex-column draggable-columns--section">
                        <span>{{ $tc('data_records.non_visible_columns') }}</span>
                        <div class="overflow-y-auto background py-1">
                            <draggable :list="columns" group="headers" @change="changeOrder">
                                <v-list-item class="main-list" dense v-for="(data, key) in columns" :key="key"
                                             :value="data" v-if="!data.show">
                                    <v-list-item-content class="main-list--content">
                                        <span>{{ data.title }}</span>
                                    </v-list-item-content>
                                </v-list-item>
                            </draggable>
                        </div>
                    </div>
                </div>
            </v-container>
        </v-card-text>
        <v-card-actions style="justify-content: center; gap: 8px">
            <v-btn class="v-btn--secondary" @click="cancel" style="width: 106px; margin: 0px !important;">
                {{ $tc('data_gatherings.cancel') }}
            </v-btn>
            <v-btn class="v-btn--primary" @click="confirm" style="width: 106px; margin: 0px !important;">
                {{ $tc('data_gatherings.accept') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

import _ from "lodash";
import {DataRecordsStore} from "@/Store/DataGatherings/DataRecordsStore";
import {mapState} from "pinia";
import draggable from 'vuedraggable';
import StrategySelectionMixin from "@/Shared/DathaGatherings/Common/Forms/StrategySelectionMixin";
import DataGatheringRepository from "@/Repositories/DataGathering/DataGatheringRepository";

export default {

    mixins: [StrategySelectionMixin],
    components: {
        draggable
    },
    data() {
        return {
            newColumnList: DataGatheringRepository.build(),
            aux: DataGatheringRepository.build(),
        }
    },

    methods: {

        changeOrder(event) {

            switch (Object.keys(event).toString()) {
                case 'added':
                    this.add(event.added);
                    break;
                case 'moved':
                    this.move(event.moved);
                    break;
            }
        },

        add(obj) {
            let index = this.dataGathering.type.options.columns.findIndex((fil) => {
                return fil.id === obj.element.id;
            });

            this.dataGathering.type.options.columns[index].show = !this.dataGathering.type.options.columns[index].show;
        },

        move(event) {
            this.dataGathering.type.options.columns.splice(event.oldIndex, 1);

            this.dataGathering.type.options.columns.splice(event.newIndex, 0, event.element);

        },

        confirm() {
            this.$emit('close');
        },

        cancel() {

            this.dataGathering.type.options.columns = this.newColumnList.type.options.columns;

            this.$emit('close');
        },
    },

    computed: {
        ...mapState(DataRecordsStore, ['columns', 'dataGathering']),
    },

    mounted() {
        this.newColumnList = _.cloneDeep(this.dataGathering);
    },

}
</script>

<style scoped lang="scss">

.bible-form {
    gap: 16px
}

</style>
